export function cloverSidebarAlertCount(
  allocateIncompleteCount: number,
  giftCardIncompleteCount: number,
): number {
  return allocateIncompleteCount + giftCardIncompleteCount
}

export function cloverSidebarAlertLabel(
  allocateIncompleteCount: number,
  giftCardIncompleteCount: number,
): string {
  const parts: string[] = []
  if (allocateIncompleteCount > 0) {
    parts.push(
      allocateIncompleteCount === 1
        ? '1 Clover date missing QuickBooks entries'
        : `${allocateIncompleteCount} Clover dates missing QuickBooks entries`,
    )
  }
  if (giftCardIncompleteCount > 0) {
    parts.push(
      giftCardIncompleteCount === 1
        ? '1 gift card month missing the correct journal entry'
        : `${giftCardIncompleteCount} gift card months missing the correct journal entry`,
    )
  }
  return parts.join('; ')
}
